import React from 'react';
import ServerError500 from '../pages/status/ServerError500.jsx';

/**
 * Catches render-time failures anywhere below it and shows the themed 500 page
 * instead of a blank screen — the framework's place for the "unexpected failure"
 * status page (the /500 route exists too, for server-signalled errors).
 */
export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.handleRetry = () => this.setState({ hasError: false });
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled UI error', error, info?.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return <ServerError500 onRetry={this.handleRetry} />;
    }
    return this.props.children;
  }
}
